{
  "payoffs": "Mortgage Payoffs",
  "search-lender-label": "Search Existing Payoff Lender",
  "search-lender-action-label": "Add New Global Lender",
  "search-employee-label": "Search Existing Employees",
  "search-employee-action-label": "Add New Employee",
  "lender-company-label": "Lender Company",
  "company-name-label": "Company Name",
  "address-label": "Address",
  "employee-label": "Employee",
  "associate_name_label": "Associate Name",
  "selected_lender_phone_number": "Phone Number",
  "selected_lender_address": "Primary Address",
  "selected_lender_mailing_address": "Mailing address",
  "selected_lender_employee_name": "Employee name",
  "selected_lender_job_title": "Job title",
  "selected_lender_email": "Email",
  "selected_lender_work_phone": "Work phone",
  "selected_lender_cellphone": "Cellphone",
  "selected_lender_change_button": "Change Lender",
  "payoff_information": "Payoff Information",
  "recording_information": "Recording Information",
  "loan": "Loan #",
  "mortgagor_snn": "Mortgagor SNN",
  "current_lien_holder": "Current Lien Holder",
  "original_mortgagee": "Original Mortgagee",
  "original_mortgagee_amount": "Original Mortgagee Amount",
  "date_mortgagee": "Date of Mortgagee",
  "date_recorded": "Date Recorded",
  "instrument": "Instrument #",
  "book": "Book",
  "page": "Page",
  "cert_of_title": "Cert of Title #",
  "doc": "Doc #",
  "line-items": "Line Items",
  "principal": "Principal",
  "interest": "Interest",
  "to": "To",
  "through": "Through",
  "additional-interest": "Additional Interest",
  "additional-interest-title": "Additional Interest Line Configuration",
  "additional-interest-subtitle": "Additional interest owed on the payoff from the “calculated thru” date to the “good thru” date.",
  "interest-calculated": "Interest Calculated",
  "from": "From",
  "interest-rate": "Interest Rate",
  "per-diem": "Per Diem",
  "escrow": "Escrow",
  "prepay-charge": "Prepay Charge",
  "late-charge": "Late Charge",
  "additional-line": "Additional line",
  "type-here": "Type here...",
  "total-due": "Total Due",
  "lender-name": "Lender Name",
  "payment-amount": "Payment Amount",
  "reference": "Reference #",
  "routing": "Routing #",
  "bank-name": "Bank Name",
  "account": "Account #",
  "account-name": "Account Name",
  "further-credit-to": "Further Credit To",
  "order-number": "Order #",
  "for-benefit-of": "For Benefit Of",
  "borrower": "Borrower",
  "settlement-agency": "Settlement Agency",
  "none": "None",
  "payments": "Payments",
  "payment": "Payment",
  "lender-selected": "Lender Selected",
  "delete-mortage": "Delete Mortage",
  "loan-information": "Loan Information",
  "property-selected": "Property Selected",
  "add-new-party": "Add New Party",
  "add-payoff": "Add Payoff",
  "add": "Add",
  "payoff": "Payoff",
  "save-charges-prompt": "Press save to record your charges",
  "no-changes": "There are no changes to save",
  "deed-date": "Deed Date",
  "recission-date": "Recission Date",
  "recorded-date": "Recorded Date",
  "certificate-title": "Certificate Title",
  "document-number": "Document Number",
  "instrument-number": "Instrument Number",
  "additional": "Additional",
  "prepay": "Prepay",
  "late": "Late",
  "add-new-line-item": "Add New Line Item",
  "not-payoffs": "There is no payoff currently selected",
  "create-one-payoff": "please select or create one",
  "add-new-mortgage": "Add Mortgage Payoff",
  "party-added-success": "Party added successfully",
  "loading": "Loading...",
  "principal-amount": "Principal Amount: {{amount}}",
  "success-party-added": "Success party added",
  "success-party-deleted": "Success party deleted",
  "no-parties-added": "No parties added",
  "success-deleted": "Success Deleted",
  "delete-payoff": "Delete Payoff",
  "delete-payoff-confirmation": "Are you sure you want to delete the mortgage payoff?",
  "original-mortgage-amount": "Original Mortgage Amount",
  "loan-number-if-known": "Loan Number (if known)",
  "none-property": "None",
  "loan-unknown": "Payoff #(unknown)",
  "delete-line-item": "Delete Line Item",
  "delete-line-item-confirmation": "Are you sure you want to delete the line item \"{{name}}\"?",
  "delete-party": "Delete Party",
  "delete-party-confirmation": "Are you sure you want to remove {{name}} as {{kind}} from this payoff?",
  "delete-party-kind": "Remove {{kind}}",
  "mortgage-created": "Mortgage payoff created",
  "saving": "Saving..."
}
